import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';

type ApplicantInfo = {
  applicationNo?: string;
  givenName: string;
  surname: string;
  applicantId?: string;
};
type GetApplicantName = {
  applicantInfo: ApplicantInfo;
  loading: boolean;
  error: ApolloError | undefined;
};

export const useGetApplicantNameByApplicationId = (
  applicationId?: string,
  applicantId?: string,
  skip?: boolean,
): GetApplicantName => {
  const emptyApplicationId = !(applicationId ?? '');
  const queryApplicationApi = gql`
    query ($id: ID!) {
      application(id: $id) {
        applicationNo
        applicant {
          name {
            givenName
            surname
          }
          _id
        }
      }
    }
  `;

  const queryApplicantApi = gql`
    query ($id: ID!) {
      applicant(id: $id) {
        name {
          givenName
          surname
        }
      }
    }
  `;

  const { data, loading, error } = useQuery(
    emptyApplicationId ? queryApplicantApi : queryApplicationApi,
    emptyApplicationId
      ? {
          variables: { id: applicantId },
          skip: !(applicantId ?? '') || skip === true,
          fetchPolicy: 'network-only',
        }
      : {
          variables: { id: applicationId },
          skip: !(applicationId ?? '') || skip === true,
          fetchPolicy: 'network-only',
        },
  );

  const applicationData = data?.application;

  const applicantInfo: ApplicantInfo = emptyApplicationId
    ? {
        givenName: data?.applicant?.name?.givenName ?? '',
        surname: data?.applicant?.name?.surname ?? '',
      }
    : {
        applicationNo: applicationData?.applicationNo,
        givenName: applicationData?.applicant?.name?.givenName ?? '',
        surname: applicationData?.applicant?.name?.surname ?? '',
        applicantId: applicationData?.applicant?._id ?? '',
      };

  return {
    applicantInfo,
    loading,
    error,
  };
};

// for applicant self
export const useGetApplicantNameByAuthEmail = (
  email: string,
  skip: boolean,
): GetApplicantName => {
  const { data, loading, error } = useQuery(
    gql`
      query ($email: String) {
        applicants(filter: { email: { eq: $email } }) {
          name {
            givenName
            surname
          }
          _id
        }
      }
    `,
    {
      variables: { email },
      skip: !email || skip,
      fetchPolicy: 'network-only',
    },
  );
  const applicationData = data?.applicants?.[0];

  const applicantInfo: ApplicantInfo = {
    givenName: applicationData?.name?.givenName ?? '',
    surname: applicationData?.name?.surname ?? '',
    applicantId: applicationData?._id ?? '',
  };

  return {
    applicantInfo,
    loading,
    error,
  };
};
